import React from 'react';
import {
	Container,
	ContainerGutter,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';

export const recogidaYentregaLayer: ServiceLayer = {
	header: 'Servicios del taller',
	title: 'Recogida y entrega',
	subtitle: (
		<Container wrap="always" gutter={ContainerGutter.static300}>
			<Text appearance={TokenTextAppearance.copy200}>
				Uno de nuestros profesionales recogerá tu Volkswagen a la hora y el lugar que decidas. Hará una revisión de su
				estado contigo, te entregará un certificado y lo acercará hasta el Servicio Oficial.
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				Cuando tu coche esté listo, podrás recogerlo tú mismo o dejar que te lo devuelva uno de nuestros profesionales.
				En ese caso, tendrás que abonar la factura online y, una vez confirmado el pago, llevará tu coche hasta donde
				hayas indicado.
			</Text>
		</Container>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0100}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				¿Y qué tienes que hacer tú?
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				<List gutter={ListGutter.dynamic0020}>
					<ListItem>Deberás cargar como mínimo un cuarto del depósito.</ListItem>
					<ListItem>Dejar la documentación de tu Volkswagen en la guantera.</ListItem>
					<ListItem>Tener el seguro al día.</ListItem>
					<ListItem>Coger todo lo que puedas necesitar mientras tu coche está en el taller.</ListItem>
					<ListItem>
						Y si necesitas un coche de sustitución, solo tienes que solicitarlo y te lo llevarán en el momento de la
						recogida de tu Volkswagen.
					</ListItem>
				</List>
			</Text>
		</Container>
	),
	imageContent:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-recogida-entrega?Zml0PWNyb3AlMkMxJndpZD04OTYmaGVpPTg5NiZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiZlMmRh',
	ctaText: 'Pide este servicio',
	link: 'action:es-cca-loader--open_layer',
};
